@if (step === 'order-cancel') {
  <app-warning-confirm-box
    [hideCancelBtn]="true"
    [confirmDetailsHeadline]="'workflow-csp-ai-tariff-order-cancel_confirm_headline' | i18next"
    [confirmDetailsText]="'workflow-csp-ai-tariff-order-cancel_confirm_text' | i18next"
    [confirmBtn]="'workflow-csp-ai-tariff-order-cancel_confirm_btn' | i18next"
    (back)="onBack()"
    (confirm)="onConfirm()">
  </app-warning-confirm-box>

  <div class="d-flex justify-content-center mt-5">
    <button
      name="cancel-order-cancel"
      class="btn btn-link"
      (click)="onBack()">
      {{ 'workflow-csp-ai-tariff-order-cancel_cancel_btn' | i18next }}
    </button>
  </div>
}